export const AppPermissions = {
    ManageActivities: 'manage activities',
    ManageContacts: 'manage contacts',
    ManageDomains: 'manage domains',
    ManageFinancial: 'manage financial',
    ManageMail: 'manage mail',
    ManageMigrations: 'manage migrations',
    ManageNotifications: 'manage notifications',
    ManageNotificationSettings: 'manage notification settings',
    ManageRedirects: 'manage redirects',
    ManageSslCertificates: 'manage ssl-certificates',
    ManageSupportMessages: 'manage support-messages',
    ManageTeams: 'manage teams',
    ManageTeamPayments: 'manage team payments',
    ManageTeamSettings: 'manage team settings',
    ManageWebOps: 'manage webops',
    ManageWebOpsRedis: 'manage webops redis',
    ManageWebOpsSshKeys: 'manage webops ssh-keys',
    ManageZones: 'manage zones',
};
